import { useAutocompleteSource } from '@eas/common-web';
import { DictRegulationOrderAutocomplete } from '@models';
import { EvidenceApiUrl } from '@enums';

export function useRegulationOrders() {
  return useAutocompleteSource<DictRegulationOrderAutocomplete>({
    url: `${EvidenceApiUrl.DICT_REGULATION_ORDER}/autocomplete`,
  });
}
